const PROD = process.env.NODE_ENV === 'production';

export const backendUrl = PROD ? process.env.REACT_APP_BACKEND_URL : '/grape';
export const backendUrlV2 = PROD ? process.env.REACT_APP_BACKEND_URLV2 : '/apiv2';
export const backendUrlFull = process.env.REACT_APP_BACKEND_FULL_URL || process.env.REACT_APP_BACKEND_URL;
export const backendConvert = PROD ? process.env.REACT_APP_CONVERT_URL : '/convert';
export const staticsRoot = PROD ? process.env.REACT_APP_STATICS_ROOT : '/static';

export const isDev = () => localStorage.getItem('dev') === 'snapper-dev';

export const acceptedImageFormats = ['jpg', 'gif', 'jpeg', 'png', 'mp4'];

export const acceptedVideoFormats = ['mp4'];
